export default function Noise() {
  // Import all our images
  function importAll(r) {
    return r.keys().map((item) => r(item));
  }

  const images = importAll(
    require.context("../../public/img/noise", false, /\.(png|jpe?g|svg)$/)
  );

  // Get a random image
  const src = images[Math.floor(Math.random() * images.length)];

  console.log(src);

  return (
    <img src={src} alt="" role="presentation" className="absolute inset-0 opacity-50 pointer-events-none object-cover w-full h-full mix-blend-multiply" />
  );
}
